var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectTypeEnhancedWeathering({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9698 19.0565L21.7154 6.9596C21.6965 6.77796 21.6102 6.61019 21.4737 6.48996L14.8771 0.679062C14.6634 0.490812 14.3598 0.44689 14.1021 0.566843L5.56815 4.54043C5.44833 4.59621 5.3461 4.68415 5.2726 4.79459L1.12161 11.0342C1.02567 11.1785 0.984377 11.3527 1.00532 11.5251L2.50482 23.8641C2.54895 24.2271 2.85512 24.5 3.21835 24.5H17.6434C17.8341 24.5 18.0169 24.4237 18.1518 24.2879L22.7632 19.6434C22.9164 19.4891 22.9923 19.2734 22.9698 19.0565ZM14.2818 2.07818L19.4775 6.65491L14.7444 7.7867L7.72997 5.1289L14.2818 2.07818ZM16.771 23.0523H4.66609L14.2984 10.2685L16.771 23.0523ZM2.46488 11.6163L6.14999 6.07704L13.5416 8.87781L3.71668 21.9172L2.46488 11.6163ZM18.0906 22.3019L15.5343 9.0858L20.3705 7.92935L21.5043 18.8637L18.0906 22.3019Z",
    fill: "#808389",
    stroke: "#808389",
    strokeWidth: 0.483746
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectTypeEnhancedWeathering);
export default __webpack_public_path__ + "static/media/project-type-enhanced-weathering.7d2b42a6bbcffbddafa5db1b475a499f.svg";
export { ForwardRef as ReactComponent };